import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { head } from 'lodash';

import { ModalCard } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';

import { useDeleteRole } from '../hooks';

const DeleteRole = ({ roles, prevData, onClose }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  const filterRoles = useMemo(
    () => roles?.filter((item) => item?.id !== prevData?.id),
    [roles, prevData],
  );

  const onError = () => setPending(false);

  const onSuccess = () => {
    onClose();
    setPending(false);
    navigate(`/access-control/roles-and-permissions/${head(filterRoles)?.id}`);
  };

  const [loading, deleteRole] = useDeleteRole(onSuccess, onError);
  const isLoading = pending || loading;

  const handleDeleteRole = () => {
    setPending(true);
    deleteRole(prevData?.id);
  };

  return (
    <ModalCard size="sm" title="CONFIRM DELETION" onClose={onClose}>
      <div className="p-4 pt-2">
        <h5 className="pb-10 font-light">
          Are you sure you want to delete
          <span className="text-brand-600"> {prevData?.name || '--'}</span>?
        </h5>

        <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
          <AsyncButton
            color="outline"
            className="text-neutral-500 font-[400]"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            color="outline"
            type="button"
            onClick={handleDeleteRole}
            className="font-[400]"
            disabled={isLoading}
            isLoading={isLoading}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

DeleteRole.propTypes = {
  roles: PropTypes.instanceOf(Array).isRequired,
  prevData: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteRole;
